const { expect } = require('chai');
const { jpath } = require('jsonpath-mapper');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

describe('Migrate assets', () => {

  describe('preview migrating an asset entry with just a payload', () => {
    const mock = loadRecordedMock('migrate_entries_asset_payload_preview.json');

    it(`should return one entry to create`, (done) => {
      migratortronApi.post(
        'migrate/entries?asset&payload',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          done();
        }
      );
    });
  });

  describe.skip('migrate an asset entry with just a payload', () => {
    const mock = loadRecordedMock('migrate_entries_commit_asset_payload.json');

    it(`should download the asset and create one entry`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?asset&payload',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(body?.entries?.migratortron?.totalCount).to.equal(1);
          expect(body?.migrateResult.created).to.equal(1);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });

  describe('repeat the same migrate an asset entry with just a payload', () => {
    const mock = loadRecordedMock(
      'migrate_entries_commit_asset_payload_repeat.json'
    );

    it(`should return one entry with no changes`, (done) => {
      migratortronApi.post(
        'migrate/entries/commit?asset&payload&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);

          expect(jpath('entries.*.totalCount', body)).to.equal(1);
          expect(jpath('existing.*.totalCount', body)).to.equal(1);
          expect(jpath('entriesToMigrate.*.totalCount', body)).to.equal(0);

          expect(body?.migrateResult.created).to.equal(0);
          expect(body?.migrateResult.updated).to.equal(0);
          expect(body?.migrateResult.errors).to.not.exist;
          done();
        }
      );
    });
  });
});
